import type { ScheduledPillProps } from './ScheduledPill.types';
import type { FC } from 'react';
import { Flex, Pill, Text, Timestamp } from '@/_components';

export const ScheduledPill: FC<ScheduledPillProps> = ({
  timestamp,
  isPreview,
}) => {
  if (!timestamp) return null;

  return (
    <Flex isYCentered={true} gap={4}>
      <Pill
        label={isPreview ? 'Scheduled (preview)' : 'Scheduled'}
        intent="secondary"
      />
      {!isPreview && (
        <Text type="tiny">
          <Timestamp timestamp={timestamp} />
        </Text>
      )}
    </Flex>
  );
};
